import { render, staticRenderFns } from "./SideBarLeftHalf.vue?vue&type=template&id=a2142194"
import script from "./SideBarLeftHalf.vue?vue&type=script&lang=js"
export * from "./SideBarLeftHalf.vue?vue&type=script&lang=js"
import style0 from "./SideBarLeftHalf.vue?vue&type=style&index=0&id=a2142194&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports